(function(){
var $=function(s){return document.querySelector(s)},$$=function(s){return [].slice.call(document.querySelectorAll(s))};
function on(el,ev,fn){if(el)el.addEventListener(ev,fn)}
// pack selector (product page only)
var P={saver:{id:'46044333735970',name:'Saver Pack · 2 × 250g',price:949},combo:{id:'68908477448226',name:'Family Combo · 2 × 1kg',price:2799},value:{id:'45219290972194',name:'Value Pack · 1kg',price:1499},small:{id:'45879003480098',name:'Small Pack · 250g',price:499}};
var sel='saver',qty=1;
function inr(n){return '₹'+n.toLocaleString('en-IN')}
function sync(){
if(!$('#buyBtn'))return;
var p=P[sel],url='/cart/'+p.id+':'+qty,total=inr(p.price*qty);
$('#buyBtn').href=url;$('#buyBtn').textContent='Buy now · '+total;
if($('#barBtn')&&$('#barName')){$('#barBtn').href=url;$('#barName').textContent=p.name+(qty>1?' × '+qty:'');$('#barPrice').textContent=total+' · free shipping'}
if($('#qOut'))$('#qOut').textContent=qty;
if($('#upsell'))$('#upsell').hidden=(sel==='combo');
}
$$('input[name=pack]').forEach(function(r){on(r,'change',function(){sel=r.value;qty=1;sync()})});
on($('#qMinus'),'click',function(){qty=Math.max(1,qty-1);sync()});
on($('#qPlus'),'click',function(){qty=Math.min(10,qty+1);sync()});
on($('#upsell'),'click',function(){var r=$('input[name=pack][value=combo]');if(r){r.checked=true;sel='combo';qty=1;sync();var l=r.closest('.pack');if(l&&l.scrollIntoView)l.scrollIntoView({block:'nearest',behavior:'smooth'})}});
var chk=$('input[name=pack]:checked');if(chk)sel=chk.value;
sync();
// gallery
$$('#thumbs button').forEach(function(b){on(b,'click',function(){
$$('#thumbs button').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});
$('#gMain').src=b.querySelector('img').src;
})});
// tick lists
var yes='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg>',no='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M18 6 6 18M6 6l12 12"/></svg>';
[['#vsOld',no],['#vsNew',yes],['#ticks',yes]].forEach(function(a){var el=$(a[0]);if(el)el.innerHTML=el.getAttribute('data-items').split('|').map(function(t){return '<li>'+a[1]+'<span>'+t+'</span></li>'}).join('')});
// ticker
if($('#tick')){var items=['Free shipping PAN India','Small-batch made','No bleaching','No anti-caking agents','Fired at 800°C','Lab-tested'],h='';
for(var k=0;k<4;k++)items.forEach(function(t){h+='<span'+(k?' aria-hidden="true"':'')+'>'+t+' <i>✦</i></span>'});
$('#tick').innerHTML=h}
// big inline video (home: how it's made)
$$('.mvid').forEach(function(b){var v=b.querySelector('video');on(b,'click',function(){
if(b.classList.contains('playing')){v.pause();b.classList.remove('playing');return}
if(!v.getAttribute('src'))v.src=b.getAttribute('data-src');
b.classList.add('playing');v.controls=true;var p=v.play();if(p&&p.catch)p.catch(function(){b.classList.remove('playing')});
})});
// testimonials strip: doctor video, Instagram reels (from the store's Instafeed feed), then quote cards
var strip=$('#reelStrip'),playIcon='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 4v16l13-8z"/></svg>',igIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>';
function videoCard(r){
var b=document.createElement('button');b.type='button';b.className='reel';b.setAttribute('aria-label','Play video: '+r.cap);
b.innerHTML='<video playsinline loop preload="none"></video><img src="'+r.poster+'" alt="" loading="lazy">'+(r.ig?'<span class="ig-badge">'+igIcon+'Instagram</span>':'')+'<span class="play">'+playIcon+'</span>'+(r.who?'<span class="who">'+r.who+'</span>':'')+'<span class="cap">'+r.cap+'</span>';
var v=b.querySelector('video');
function stop(){v.pause();b.classList.remove('playing')}
b.addEventListener('click',function(){
if(b.classList.contains('playing')){stop();return}
$$('.reel.playing').forEach(function(o){o.querySelector('video').pause();o.classList.remove('playing')});
if(!v.getAttribute('src'))v.src=r.video;
b.classList.add('playing');
var p=v.play();if(p&&p.catch)p.catch(function(){b.classList.remove('playing')});
});
if('IntersectionObserver' in window)new IntersectionObserver(function(e){if(!e[0].isIntersecting)stop()},{threshold:.4}).observe(b);
return b;
}
function quoteCard(r){var q=document.createElement('article');q.className='reel qt';q.innerHTML='<span class="stars" aria-hidden="true">★★★★★</span><p>“'+r.quote+'”</p><footer>'+r.name+'<span>'+r.ctx+'</span></footer>';return q}
if(strip){
strip.appendChild(videoCard({video:'https://cdn.shopify.com/videos/c/vp/dd7947aaee3c4f5a8880b237105d9439/dd7947aaee3c4f5a8880b237105d9439.HD-720p-4.5Mbps-90998339.mp4',poster:'https://cdn.shopify.com/s/files/1/0805/9571/4082/files/preview_images/dd7947aaee3c4f5a8880b237105d9439.thumbnail.0000000000.jpg?v=1786086872',cap:'A doctor\'s take',who:'Watch with sound'}));
[{quote:'Even my husband noticed and asked what I did different.',name:'Sangeetha',ctx:'On her rasam'},{quote:'Never thought I\'d be writing a review for salt.',name:'Dinesh',ctx:'Using it every day'},{quote:'Feels light and not harsh.',name:'Meera',ctx:'Yoga teacher, Mysore'},{quote:'Ordered another pack for my parents too.',name:'Melvin',ctx:'Came for the hype, stayed'}].forEach(function(r){strip.appendChild(quoteCard(r))});
}
// Instagram: Instafeed renders the feed into a hidden holder; each reel is copied into the strip as a card
var igSrc=document.getElementById('feed-47950'),igSeen={};
function pullIG(){
if(!igSrc||!strip)return;
$$('#feed-47950 .instafeed-new-layout-item video').forEach(function(v){
var src=v.getAttribute('src')||v.currentSrc;if(!src||igSeen[src])return;igSeen[src]=1;
var card=videoCard({video:src,poster:v.getAttribute('poster')||v.getAttribute('data-poster')||'',cap:'From our Instagram',ig:true});
var firstQuote=strip.querySelector('.reel.qt');strip.insertBefore(card,firstQuote);
try{v.pause();v.removeAttribute('autoplay')}catch(e){}
});
}
if(igSrc&&'MutationObserver' in window){new MutationObserver(pullIG).observe(igSrc,{childList:true,subtree:true,attributes:true,attributeFilter:['src']});pullIG()}
// buy buttons: put the chosen pack in the cart, then open GoKwik checkout (Shopify checkout if GoKwik isn't available)
function gokwikReady(){return typeof window.triggerGokwikCustomCheckout==='function'&&window.gokwikSdk}
function openCheckout(a){
var tries=0;
(function attempt(){
if(gokwikReady()){
try{if(window.gokwikSdk.triggerLoadingScreen)window.gokwikSdk.triggerLoadingScreen()}catch(e){}
try{window.triggerGokwikCustomCheckout();setTimeout(function(){delete a.dataset.busy;a.classList.remove('busy')},3000);return}catch(e){}
}
if(++tries<20){setTimeout(attempt,150);return}
location.href='/checkout';
})();
}
document.addEventListener('click',function(e){
var a=e.target.closest('a[href^="/cart/"]');if(!a)return;
var m=a.getAttribute('href').match(/\/cart\/(\d+):(\d+)/);if(!m)return;
e.preventDefault();if(a.dataset.busy)return;a.dataset.busy='1';a.classList.add('busy');
fetch('/cart/clear.js',{method:'POST'}).then(function(){
return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+m[1],quantity:+m[2]}]})});
}).then(function(r){if(!r.ok)throw r;return fetch('/cart.js').then(function(c){return c.json()}).then(function(c){window.cart=c})}).then(function(){openCheckout(a)}).catch(function(){location.href=a.getAttribute('href')});
});
// sticky bar: show once the main call to action is out of view
var bar=$('#bar'),anchor=$('#buyBtn')||$('#heroCta');
function onScroll(){if(bar&&anchor)bar.classList.toggle('on',anchor.getBoundingClientRect().bottom<0)}
addEventListener('scroll',onScroll,{passive:true});onScroll();
})();
